/**
 * F14.2 — el perfil offline desbloqueado no es el del usuario de la sesión en línea (`offline/identidad-sync.ts`):
 * no se ha enviado nada. Las dos salidas razonables: entrar con la cuenta del perfil, o bloquearlo. La cola no se
 * toca en ninguno de los dos casos.
 */
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

import { useSesionOpcional } from '../contexto.tsx';
import { MENSAJE_PERFIL_DE_OTRO_USUARIO } from '../offline/identidad-sync.ts';
import { bloquearPerfilActivo } from '../offline/perfil.ts';

export function AvisoPerfilDeOtroUsuario(): ReactNode {
  const sesion = useSesionOpcional();
  const navegar = useNavigate();
  return (
    <div className="nota aviso" role="alert" style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <p style={{ margin: 0 }}>{MENSAJE_PERFIL_DE_OTRO_USUARIO}</p>
      <div className="fila" style={{ gap: 8, flexWrap: 'wrap' }}>
        <button
          type="button"
          className="pequeno"
          onClick={() => {
            //  Cerrar la sesión actual bloquea también el perfil (`contexto.tsx::salir`); sus datos siguen cifrados.
            void sesion?.salir().finally(() => navegar('/entrar'));
          }}
        >
          Iniciar sesión
        </button>
        <button type="button" className="pequeno" onClick={() => bloquearPerfilActivo()}>
          Bloquear perfil
        </button>
      </div>
    </div>
  );
}
